export enum PaymentType {
  Cash = 'Cash',
  Card = 'Card',
}
